import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<CreateOptionsDatetime @poll={{@model}} />",{ moduleName: "@croodle/client/templates/create/options-datetime.hbs" })